import { mediator } from '@ioc/mediator'
import { RequestData } from 'mediatr-ts'

export class SignOutCommand extends RequestData {}

export const signOut = () => mediator.send(new SignOutCommand())
